"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prettier/prettier */
const react_1 = __importStar(require("react"));
const dynamic_1 = __importDefault(require("next/dynamic"));
const next12_components_icon_n_1 = __importDefault(require("@gcloud-npm/next12.components.icon-n"));
const react_redux_1 = require("react-redux");
const next12_app_controller_reducers_sagas_modals_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer");
const next12_components_custom_link_1 = __importDefault(require("@gcloud-npm/next12.components.custom-link"));
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const ModalMenu = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require("../../../modals/burger"))));
class BurgerMenu extends react_1.Component {
    constructor(props) {
        super(props);
        this.handleBurgerModal = () => __awaiter(this, void 0, void 0, function* () {
            const { addModal, items, segmentMenu, options, account, modals } = this.props;
            const device = (0, next12_utils_common_1.getDeviceKindDependsOnViewPort)();
            if (modals.length > 0) {
                addModal({ id: "closeAll" });
            }
            addModal({
                id: "menu",
                Element2Show: ModalMenu,
                modalProps: {
                    contentPosition: "left--top",
                    opacityLayoutColor: "blur",
                    inSceneEffect: "fadeInLeft",
                    contentInsideContainer: false,
                    outSceneEffect: "fadeOutLeft",
                    closeByClickingOutside: true,
                    scrollAllowed: false,
                },
                elementProps: {
                    items: Object.assign({}, items),
                    segmentMenu: Object.assign({}, segmentMenu),
                    options: Object.assign({}, options),
                    account: Object.assign({}, account),
                },
            });
        });
    }
    render() {
        return (react_1.default.createElement(next12_components_custom_link_1.default, { onClick: this.handleBurgerModal, title: "Men\u00FA", ariaLabel: "Men\u00FA", className: "button", taggingInfo: {
                componentName: "header",
                componentContent: "openBurger",
                componentVariation: "all",
                componentPerso: "",
                componentProduct: "",
            }, cyData: "Header burger" },
            react_1.default.createElement(next12_components_icon_n_1.default, { id: "menu", kind: "M", size: 24, color: "grey6" })));
    }
}
const mapStateToProps = (state) => ({
    modals: state.modals.modalHistory,
});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next12_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(BurgerMenu);
//# sourceMappingURL=index.js.map